var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfghanistanCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 250,
    viewBox: "0 0 650 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 250,
    fill: "#78C40E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591,
    width: 59,
    height: 250,
    fill: "#78C40E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 0H149V250H59V0Z",
    fill: "#C0162D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 0H591V250H501V0Z",
    fill: "#C0162D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149,
    width: 65,
    height: 250,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436,
    width: 65,
    height: 250,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 0H332V250H317V0Z",
    fill: "#00155C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 0H303V250H288V0Z",
    fill: "#C0162D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 0H361V250H346V0Z",
    fill: "#C0162D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfghanistanCampaign);
export default __webpack_public_path__ + "static/media/Afghanistan Campaign.777c00af95b98d21a6af09b66793b80d.svg";
export { ForwardRef as ReactComponent };